import Page from 'containers/OfficesPage'

export default Page
